/**
 * @file index.tsx
 * @deprecated Copied to app/modules/procurement/pages/escalations/index.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/escalations/index
 * @description Router container for Escalations module. Defines routes for escalation 
 *   list and details views. Manages navigation between sub-pages and maintains page 
 *   title/breadcrumb context using uTrade layout components.
 * 
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo [P2] Fix breadcrumb route paths to match registered private routes
 *   and prevent broken breadcrumb navigation.
 * @todo [P3] Add route-level permission guards using POManagement or equivalent
 *   escalation permission constant from utils/constants.ts.
 */

import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import Escalations from "./Escalations";
import EscalationDetails from "./EscalationDetails";
import { PageLink, PageTitle } from "../../../../_admin/layout/core";
const escalationBreadCrumbs: Array<PageLink> = [
  {
    title: 'UProcure',
    path: '/UProcure',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const escalationv2BreadCrumbs: Array<PageLink> = [
  {
    title: 'UProcure',
    path: '/UProcure',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Escalations',
    path: '/escalations',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const EscalationPage = () => {
  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route
            path="/"
            element={
              <>
                <PageTitle breadcrumbs={escalationBreadCrumbs}>
                  Escalations
                </PageTitle>
                <Escalations />
              </>
            } 
            />
          <Route
            path="/escalation-details"
            element={
              <>
                <PageTitle breadcrumbs={escalationv2BreadCrumbs}>
                  Escalation Details
                </PageTitle>
                <EscalationDetails />
              </>
            }
          />
        </Route>
      </Routes>
    </>
  );
};

export default EscalationPage;
